import { Outlet } from "react-router-dom";

import { ProductSubscriptionsProvider } from "@/modules/productSubscriptions";
import { ThemeProvider } from "providers/ThemeProvider";

export const Component = () => {
  return (
    <ProductSubscriptionsProvider>
      <ThemeProvider>
        <Outlet />
      </ThemeProvider>
    </ProductSubscriptionsProvider>
  );
};
